import { render, staticRenderFns } from "./TyCos.vue?vue&type=template&id=2554b003&scoped=true"
import script from "./TyCos.vue?vue&type=script&lang=js"
export * from "./TyCos.vue?vue&type=script&lang=js"
import style0 from "./TyCos.vue?vue&type=style&index=0&id=2554b003&prod&lang=scss&scoped=true"
import style1 from "./TyCos.vue?vue&type=style&index=1&id=2554b003&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554b003",
  null
  
)

export default component.exports